export enum QueryContext
{
  None = 1,
  Search = 2,
  Recommended = 3,
  Dashboard = 4,
}
